export var printInvoiceStyles = {
    dialogPaper: {
        margin: "32px",
        maxWidth: "750px",
        width: "100%",
        borderRadius: "20px",
        maxHeight: "calc(100vh - 64px)",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
    },
    dialogWrapper: {
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f5f5f5",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        maxHeight: "100%",
        overflow: "hidden",
    },
    printHeaderBox: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "12px 16px",
        backgroundColor: "#f5f5f5",
        flexShrink: 0,
    },
    printHeaderTypography: {
        fontWeight: 600,
        color: "#000",
        fontSize: "16px",
    },
    closeIconButton: {
        color: "#333",
        padding: "4px",
        "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.05)",
        },
    },
    closeIcon: {
        fontSize: "20px",
    },
    printableInvoice: {
        padding: "16px 30px 20px 30px",
        backgroundColor: "#fff",
        WebkitPrintColorAdjust: "exact",
        printColorAdjust: "exact",
        overflowY: "auto",
        overflowX: "hidden",
        flex: 1,
        minHeight: 0,
        scrollbarWidth: "thin",
        scrollbarColor: "#1976d2 #f1f1f1",
        "&::-webkit-scrollbar": {
            width: "8px",
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "#f1f1f1",
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#1976d2",
            borderRadius: "4px",
            "&:hover": {
                backgroundColor: "#1565c0",
            },
        },
    },
    invoiceHeaderBox: {
        mb: 1.2,
    },
    invoiceTitleTypography: {
        fontWeight: 700,
        color: "#000",
        fontSize: "18px",
    },
    orderDetailsRow: {
        display: "flex",
        gap: 3,
        mb: 0.8,
    },
    orderDetailsBox: {
        flex: 1,
    },
    orderDetailsTypography: {
        fontSize: "12px",
        color: "#000",
    },
    dividerBox: {
        position: "relative",
        borderBottom: "1px solid #e0e0e0",
        mb: 1.2,
    },
    badgeBox: {
        position: "absolute",
        top: "-34px",
        right: "8px",
        color: "#fff",
        padding: "4px 12px",
        borderRadius: "5px",
        fontWeight: 600,
        fontSize: "11px",
        zIndex: 10,
    },
    threeBoxContainer: {
        display: "flex",
        border: "1px solid #ddd",
        borderRadius: "0px",
        mb: 1.2,
    },
    boxWithBorder: {
        flex: 1,
        padding: "10px",
        backgroundColor: "#fff",
        borderRight: "1px solid #ddd",
        wordBreak: "break-word",
        overflowWrap: "break-word",
    },
    boxWithoutBorder: {
        flex: 1,
        padding: "10px",
        backgroundColor: "#fff",
        wordBreak: "break-word",
        overflowWrap: "break-word",
    },
    sectionTitleTypography: {
        fontWeight: 700,
        mb: 0.4,
        fontSize: "11px",
        color: "#000",
    },
    sectionContentTypography: {
        fontSize: "11px",
        color: "#555",
        lineHeight: 1.4,
        wordBreak: "break-word",
        overflowWrap: "break-word",
    },
    addressTypography: {
        fontSize: "11px",
        color: "#555",
        whiteSpace: "pre-line",
        lineHeight: 1.4,
        wordBreak: "break-word",
        overflowWrap: "break-word",
    },
    twoBoxContainer: {
        display: "flex",
        border: "1px solid #ddd",
        borderRadius: "0px",
        mb: 1.5,
    },
    notesBox: {
        flex: "0 0 33.5%",
        padding: "10px",
        backgroundColor: "#fff",
        borderRight: "1px solid #ddd",
        wordBreak: "break-word",
        overflowWrap: "break-word",
    },
    additionalDetailsBox: {
        flex: 1,
        padding: "10px",
        backgroundColor: "#fff",
        wordBreak: "break-word",
        overflowWrap: "break-word",
    },
    dividerLine: {
        borderBottom: "1px solid #e0e0e0",
        mb: 1,
    },
    tableContainer: {
        mb: 1.5,
        border: "1px solid #ddd",
    },
    tableHeadRow: {
        backgroundColor: "#f8f8f8",
    },
    tableHeaderCell: {
        fontWeight: 700,
        fontSize: "12px",
        color: "#000",
        padding: "10px 8px",
        borderBottom: "1px solid #ddd",
        borderRight: "1px solid #ddd",
    },
    tableHeaderCellCenter: {
        fontWeight: 700,
        fontSize: "12px",
        color: "#000",
        padding: "10px 8px",
        borderBottom: "1px solid #ddd",
        borderRight: "1px solid #ddd",
        textAlign: "center",
    },
    tableHeaderCellNoBorder: {
        fontWeight: 700,
        fontSize: "12px",
        color: "#000",
        padding: "10px 8px",
        borderBottom: "1px solid #ddd",
        textAlign: "right",
    },
    productNameTypography: {
        fontSize: "12px",
        color: "#000",
        mb: 0.4,
        wordBreak: "break-word",
        overflowWrap: "break-word",
    },
    variantTypography: {
        fontSize: "11px",
        color: "#666",
        backgroundColor: "#f5f5f5",
        padding: "2px 5px",
        borderRadius: "3px",
        display: "inline-block",
        wordBreak: "break-word",
        overflowWrap: "break-word",
    },
    priceStrikethrough: {
        textDecoration: "line-through",
        color: "#999",
        fontSize: "11px",
        display: "block",
    },
    priceTypography: {
        fontSize: "12px",
        color: "#000",
    },
    emptyTableCell: {
        textAlign: "center",
        fontSize: "12px",
        padding: "18px",
        color: "#999",
        borderBottom: "none",
    },
    summaryContainer: {
        display: "flex",
        justifyContent: "flex-end",
        mb: 0,
    },
    summaryBox: {
        minWidth: "240px",
    },
    summaryRow: {
        display: "grid",
        gridTemplateColumns: "1fr 120px",
        alignItems: "center",
        py: 0.8,
        borderBottom: "1px solid #f0f0f0",
    },
    summaryRowNoBorder: {
        display: "flex",
        justifyContent: "space-between",
        py: 0.8,
    },
    summaryLabel: {
        fontSize: "13px",
        fontWeight: 600,
        color: "#000",
    },
    summaryValue: {
        fontSize: "13px",
        color: "#000",
        textAlign: "right",
    },
    totalBox: {
        display: "grid",
        gridTemplateColumns: "1fr 120px",
        alignItems: "center",
        py: 1.2,
        backgroundColor: "#f5f5f5",
        borderRadius: "4px",
        mt: 0.5,
    },
    totalTypography: {
        fontSize: "15px",
        fontWeight: 700,
        color: "#000",
    },
    totalValueTypography: {
        fontSize: "15px",
        fontWeight: 700,
        color: "#000",
        textAlign: "right",
    },
    printButtonContainer: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        backgroundColor: "#fff",
        borderTop: "1px solid #e0e0e0",
        padding: "16px 24px",
        flexShrink: 0,
        zIndex: 1,
    },
    printButton: {
        textTransform: "none",
        paddingX: 3,
        paddingY: 0.75,
        fontSize: "14px",
        fontWeight: 500,
        backgroundColor: "#1976d2",
        borderRadius: "6px",
        minWidth: "100px",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "#1565c0",
            boxShadow: "none",
        },
    },
};
// Helper function for table cell styles
export var getTableCellStyle = function (isLastRow, hasRightBorder, textAlign) {
    if (textAlign === void 0) { textAlign = "left"; }
    return {
        fontSize: "12px",
        color: "#000",
        padding: "10px 8px",
        borderBottom: isLastRow ? "none" : "1px solid #ddd",
        borderRight: hasRightBorder ? "1px solid #ddd" : "none",
        textAlign: textAlign,
        wordBreak: "break-word",
        overflowWrap: "break-word",
    };
};
